import { createValidation } from '../../../utils/validation';

export const createComplaintForwardToValidation = (fields) => {
  const validation = createValidation(fields);
  return {
    schema: validation.schema,
    validateData: validation.validateData,
    validateComplaintForwardToData: validation.validateData,
    validateField: validation.validateField
  };
};

export default createComplaintForwardToValidation;

